import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import size from 'lodash/size';
import map from 'lodash/map';

import SectionTitle from '../SectionTitle/SectionTitle';
import styles from './FriendsList.module.css';

const FriendsList = ({ friendsList }) => {
  const singleFriend = size(friendsList) === 1;
  return (
    <div className={styles.container}>
      <SectionTitle
        title="My Invites"
        subtitle="You can invite anyone who is new to FabFitFun to shop the sale with you. Who will it be?"
      />
      <div
        className={classNames(styles.list, {
          [styles.singleFriend]: singleFriend,
        })}
      >
        <div className={styles.listContainer}>
          <ul>
            {map(friendsList, (item, i) => (
              <li key={i}>{item.name}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

FriendsList.propTypes = {
  friendsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
};

FriendsList.defaultProps = {
  friendsList: [],
};

export default FriendsList;
